import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { usePlaidLink } from "react-plaid-link";
import { get, post } from "../../api/";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { updateCurrentScreen } from "../../utils";
let count = 0;
let config = {};
let linkData;
const PlaidLink = () => {
    const navigate = useNavigate();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    const [linkIVDToken, setLinkIVDToken] = useState("");
    const [linkIncomeToken, setLinkIncomeToken] = useState("");
    const [linkOtherToken, setLinkOtherToken] = useState("");
    const [linkToken, setLinkToken] = useState("");

    useEffect(() => {
        createLinkToken();
    }, []);

    const createLinkToken = async () => {
        const resultIDV = await post("plaid/create_link_token", {
            userId: userDetails?.applicant?.id,
            type: "identity-verification",
        });
        if (resultIDV.isSuccess) {
            setLinkIVDToken(resultIDV.data.link_token);
            setLinkToken(resultIDV.data.link_token);
        }
    };

    const onIDVSuccess = async (publicToken, metadata) => {
        await doneWithIDV(metadata);
    };
    const onIDVEvent = async (eventName, metadata) => {
        if (eventName === "IDENTITY_VERIFICATION_START_STEP") {
            const result = await post("plaid/set_recent_idv_session", {
                userId: userDetails?.applicant?.id,
                idvSession: metadata["link_session_id"],
            });
            if (result.isSuccess) {
                userDetails.applicant.identityVerifivationSessionId = metadata["link_session_id"];
                setUserDetailsNotAsync(userDetails);
            }
        }
    };
    const onIDVExit = async (err, metadata) => {
        await doneWithIDV(metadata);
    };

    const doneWithIDV = async (metadata) => {
        const result = await post("plaid/idv_complete", {
            userId: userDetails?.applicant?.id,
            contactId: userDetails?.applicant?.contact?.id,
            idvSession: metadata["link_session_id"],
        });

        if (result.isSuccess) {
            userDetails.applicant = result.data;
            setUserDetailsNotAsync(userDetails);
            if (userDetails.applicant.identityVerifivationStatus === "success") {
                //navigateToApplication();
                const plaidIDVEvent = new CustomEvent("plaidIDVEvent", {
                    detail: { type: "success" },
                });
                document.dispatchEvent(plaidIDVEvent);
            } else {
                const plaidIDVEvent = new CustomEvent("plaidIDVEvent", {
                    detail: { type: "failed" },
                });
                document.dispatchEvent(plaidIDVEvent);
            }
        } else {
            console.log(result.errorMessage);
        }
    };

    config = {
        token: linkIVDToken,
        onSuccess: onIDVSuccess,
        onEvent: onIDVEvent,
        onExit: onIDVExit,
    };

    linkData = usePlaidLink(config);

    const navigateToApplication = () => {
        document.querySelector("#next-btn").click();
    };

    const handleOnClick = () => {
        linkData.open();
    };

    return (
        <Button
            color="primary"
            type="submit"
            fullWidth
            variant="contained"
            sx={{
                height: "45px",
                backgroundColor: "#0D2D3A",
            }}
            onClick={() => handleOnClick()}
            disabled={linkToken && linkData?.ready ? false : true}
        >
            Verify your Identity
        </Button>
    );
};

export { PlaidLink };
